type Link = {
	url: string;
	svg: boolean;
	icon: string;
	title: string;
};

class Socials extends HTMLElement {
	private items: Link[] = [
		{
			url: 'https://atanas.info',
			title: 'Go to my website',
			icon: 'logo',
			svg: true
		},
		{
			url: 'mailto:hi@atanas.info',
			title: 'Send me an email',
			icon: 'email',
			svg: true
		},
		{
			url: 'https://www.linkedin.com/in/scriptex/',
			title: 'Find me on LinkedIn',
			icon: 'linkedin',
			svg: true
		},
		{
			url: 'https://github.com/scriptex',
			title: 'See my projects on Github',
			icon: 'github',
			svg: true
		},
		{
			url: 'https://gitlab.com/scriptex',
			title: 'See my projects on Gitlab',
			icon: 'gitlab',
			svg: true
		},
		{
			url: 'https://twitter.com/scriptexbg',
			title: 'Follow me on Twitter',
			icon: 'twitter',
			svg: true
		},
		{
			url: 'https://www.npmjs.com/~scriptex',
			title: 'See my packages on NPM',
			icon: 'npm',
			svg: true
		},
		{
			url: 'https://www.youtube.com/user/scriptex',
			title: 'See my videos on YouTube',
			icon: 'youtube',
			svg: true
		},
		{
			url: 'https://stackoverflow.com/users/4140082/atanas-atanasov',
			title: 'See my profile on StackOverflow',
			icon: 'stackoverflow',
			svg: true
		},
		{
			url: 'https://codepen.io/scriptex/',
			title: 'See my work on Codepen',
			icon: 'codepen',
			svg: true
		},
		{
			url: 'https://profile.codersrank.io/user/scriptex',
			title: 'See my profile on Codersrank',
			icon: 'codersrank',
			svg: true
		},
		{
			url: 'https://linktr.ee/scriptex',
			title: 'See the rest of my links on Linktree',
			icon: 'linktree',
			svg: true
		}
	];

	private styleEl: HTMLStyleElement = document.createElement('style');
	private sprite: HTMLTemplateElement = document.createElement('template');
	private template: HTMLTemplateElement = document.createElement('template');

	constructor() {
		super();

		this.render();

		const shadowRoot = this.attachShadow({ mode: 'open' });

		// prettier-ignore
		this.sprite.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" style="width: 0; height: 0; position: absolute;"><symbol id="svg-codepen" viewBox="0 0 470 470"><g fill-rule="evenodd"><path d="M234.55 430.576c-108.092 0-196.028-87.939-196.028-196.027S126.458 38.522 234.549 38.522c108.087 0 196.023 87.94 196.023 196.027 0 108.088-87.936 196.027-196.023 196.027M234.55 0C105.01 0 0 105.01 0 234.55s105.008 234.545 234.55 234.545c129.536 0 234.544-105.005 234.544-234.546C469.094 105.01 364.086 0 234.55 0"></path><path d="m354.644 255.407-31.18-20.858 31.18-20.857zM247.012 343.82v-58.133l54.034-36.138 43.62 29.172-97.654 65.1zm-12.463-79.784-44.084-29.486 44.084-29.486 44.08 29.486zm-12.466 79.784-97.653-65.1 43.623-29.172 54.031 36.138v58.133zM114.451 213.692l31.183 20.857-31.183 20.858zm107.632-88.413v58.133l-54.031 36.146-43.623-29.18zm24.929 0 97.654 65.098-43.62 29.181-54.034-36.146V125.28zm132.45 63.458c-.026-.183-.072-.358-.102-.54a12 12 0 0 0-.219-1.047c-.054-.206-.13-.404-.194-.602-.1-.306-.199-.61-.32-.908a12 12 0 0 0-.279-.61 9 9 0 0 0-.423-.824c-.115-.199-.237-.39-.355-.58a14 14 0 0 0-.954-1.298 12 12 0 0 0-.621-.67c-.163-.168-.325-.336-.497-.489a14 14 0 0 0-.705-.595c-.187-.145-.37-.29-.565-.427-.072-.046-.137-.107-.206-.153L241.461 91.62a12.46 12.46 0 0 0-13.828 0l-132.56 88.374c-.07.046-.134.107-.206.153-.196.137-.379.282-.562.427q-.367.286-.705.595c-.175.153-.335.321-.5.488a11 11 0 0 0-1.048 1.213q-.277.366-.524.756a10.4 10.4 0 0 0-.782 1.404c-.094.198-.194.404-.277.61-.122.297-.221.602-.322.908-.065.198-.137.396-.194.602-.091.343-.153.694-.218 1.046-.03.183-.076.358-.099.541a12 12 0 0 0-.114 1.625v88.374c0 .55.041 1.091.114 1.633.023.176.07.358.1.533.064.352.126.702.218 1.046.056.206.129.404.194.603.1.304.199.61.32.915.084.207.183.405.278.603.135.281.272.556.425.831q.169.287.357.572.247.39.523.756c.138.191.282.366.431.541.195.23.401.458.618.672.165.167.325.335.5.487q.339.312.706.596c.183.146.365.29.56.427.073.046.138.107.207.152l132.56 88.375a12.46 12.46 0 0 0 6.916 2.098c2.407 0 4.817-.702 6.911-2.098l132.562-88.375c.07-.045.134-.106.207-.152.194-.137.377-.28.564-.427q.36-.284.705-.596c.172-.152.334-.32.497-.487.216-.214.423-.443.621-.672.146-.175.29-.35.427-.54.188-.245.36-.497.527-.757.118-.19.24-.38.355-.572.156-.275.292-.55.423-.83.095-.199.193-.397.279-.604.121-.305.22-.61.32-.915.065-.199.14-.397.195-.603.091-.344.156-.694.218-1.046.03-.175.075-.357.101-.533.07-.542.113-1.084.113-1.633v-88.374c0-.549-.043-1.09-.113-1.625z"></path></g></symbol><symbol id="svg-codersrank" viewBox="0 0 63 41"><g fill="none" stroke="#FFF"><path fill="#19223C" d="M34.25 1.055 3.147 20.635Q.95 21.964 1.001 23.612v2.98q.052 1.65 2.2 2.926l15.393 8.885a.726.726 0 0 0 1.047-.373l3.456-8.352-7.33-4.15a1.32 1.32 0 0 1-.697-.976 1.345 1.345 0 0 1 .644-1.365l13.457-8.247 5.55-13.512a.32.32 0 0 0-.104-.36.31.31 0 0 0-.369-.013z"></path><path fill="#67A4AC" d="M59.8 11.962 44.618 2.758a.726.726 0 0 0-1.047.32l-3.56 8.352 7.225 4.31c.208.113.381.282.502.488a1.347 1.347 0 0 1-.502 1.853l-13.56 7.98-5.76 13.407a.323.323 0 0 0 .131.515.31.31 0 0 0 .34-.09l9.948-6.011 3.927 5.64a.95.95 0 0 0 .785.425h9.425a.93.93 0 0 0 .832-.506.97.97 0 0 0-.047-.984l-6.388-9.79 12.933-7.82q2.2-1.33 2.2-2.98V14.94q0-1.649-2.2-2.98H59.8z"></path></g></symbol><symbol id="svg-email" viewBox="0 0 15 17"><path fill-rule="evenodd" d="M10.38 14.774v1.556q-1.476.37-2.69.37-3.48 0-5.585-2.207T0 8.648q0-3.673 2.276-6.16Q4.553-.001 7.92 0q2.954 0 4.755 2.017 1.802 2.018 1.802 5.322 0 2.443-.906 3.845-.905 1.402-2.487 1.402-.835 0-1.318-.396-.484-.395-.844-1.388-1.371 1.785-2.804 1.784-1.274 0-2.004-.9-.73-.903-.73-2.484 0-2.355 1.258-3.823Q5.897 3.91 7.91 3.91q.65 0 2.522.158v4.527l.017.817q0 1.705.967 1.705 1.512 0 1.512-3.595 0-2.662-1.389-4.32-1.389-1.656-3.63-1.656-2.628 0-4.495 2.057-1.868 2.056-1.868 4.948 0 2.936 1.731 4.772t4.492 1.837q1.15 0 2.61-.387zm-1.9-9.237a2.2 2.2 0 0 0-.808-.167q-2.285 0-2.285 3.542 0 2.074 1.239 2.074.835 0 1.854-1.678v-3.77z"></path></symbol><symbol id="svg-github" viewBox="0 0 137 131"><path fill-rule="evenodd" d="M9.164 33.44q9.165-15.431 24.868-24.435Q49.734-.001 68.33 0t34.298 9.005q15.705 9.004 24.868 24.434 9.165 15.43 9.164 33.701 0 21.944-13.034 39.472t-33.676 24.26q-2.402.436-3.514-.613c-.742-.699-1.496-1.874-1.496-2.923v-18.322c0-5.653-1.159-9.615-4.243-12.237q5.07-.525 9.12-1.574 4.047-1.05 8.363-3.41 4.315-2.359 7.207-5.813t4.715-9.18q1.824-5.725 1.824-13.156 0-10.58-7.029-18.01 3.293-7.955-.712-17.834-2.49-.787-7.206.962-4.715 1.749-8.186 3.847l-3.38 2.098q-8.275-2.273-17.083-2.273t-17.082 2.273q-1.425-.962-3.782-2.36-2.358-1.4-7.429-3.366-5.07-1.968-7.651-1.18-3.915 9.878-.623 17.834-7.029 7.43-7.029 18.009 0 7.431 1.824 13.113t4.671 9.18q2.847 3.495 7.162 5.857 4.316 2.36 8.363 3.41 4.05 1.047 9.12 1.573-3.56 3.147-4.36 9.004a18 18 0 0 1-4.003 1.312q-2.136.436-5.072.437-2.936 0-5.827-1.88t-4.938-5.464q-1.691-2.797-4.315-4.546-2.625-1.748-4.404-2.098l-1.78-.262q-1.868 0-2.58.393-.712.394-.445 1.006.267.611.8 1.223.535.612 1.158 1.05l.622.437q1.957.874 3.87 3.322t2.803 4.458l.89 2.01q1.157 3.324 3.915 5.377 2.757 2.055 5.96 2.623 3.204.569 6.184.612t4.938-.306l2.77-.975c0 2.215-.03 5.273 0 8.245.03 2.973 0 4.406 0 4.58 0 1.05-1.02 2.225-1.791 2.924q-1.157 1.05-3.559.612-20.641-6.73-33.676-24.26Q0 89.085 0 67.142q0-18.273 9.164-33.704z"></path></symbol><symbol id="svg-gitlab" viewBox="0 0 430 397"><path d="m429.05 226.61-24-74L357.36 6a8.19 8.19 0 0 0-15.58 0l-47.66 146.62H135.88L88.22 6a8.19 8.19 0 0 0-15.58 0L25 152.62l-24 74a16.38 16.38 0 0 0 6 18.31l208 151.16 208.1-151.17a16.38 16.38 0 0 0 6-18.31"></path><path d="m215 396.09 79.12-243.47H135.88z"></path><path fill-opacity=".5" d="m215 396.09-79.12-243.47H25z"></path><path d="m25 152.62-24 74a16.37 16.37 0 0 0 6 18.31l208 151.16zm0 0h110.88L88.22 6a8.19 8.19 0 0 0-15.58 0z"></path><path fill-opacity=".5" d="m215 396.09 79.12-243.47H405z"></path><path d="m405 152.62 24 74a16.37 16.37 0 0 1-6 18.31L215 396.09zM405 152.62H294.12L341.78 6a8.19 8.19 0 0 1 15.58 0z"></path></symbol><symbol id="svg-linkedin" viewBox="0 0 125 118"><path fill-rule="evenodd" d="M0 13.745Q0 7.797 4.191 3.9 8.382 0 15.137 0c6.755 0 8.11 1.3 10.823 3.899q4.07 3.898 4.15 9.846.082 5.868-4.109 9.807T14.974 27.49h-.163q-6.674 0-10.742-3.938Q-.001 19.613 0 13.745M1.546 118V38.342h26.856V118zm41.667 0q.162-32.073.163-52.007c.001-19.934-.027-21.22-.082-23.793l-.081-3.858h26.774v11.575h-.163q1.627-2.572 3.337-4.501t4.598-4.18q2.889-2.25 7.08-3.497 4.191-1.245 9.318-1.246 13.916 0 22.38 9.123 8.462 9.125 8.463 26.727V118H98.226V75.398q0-8.44-3.296-13.223-3.296-4.782-10.295-4.783-5.127 0-8.585 2.774a17.1 17.1 0 0 0-5.168 6.872q-.895 2.412-.895 6.511V118z"></path></symbol><symbol id="svg-linktree" viewBox="0 0 30 25"><path fill="#39E09B" d="M11.2.688c-.5-.9-1.8-.9-2.3 0l-8.6 15.6c-.399.8.2 1.7 1.101 1.7h5.8v5.9c0 .6.5 1.1 1.1 1.1h3.4c.6 0 1.1-.5 1.1-1.1v-5.9h-1.6c-.7 0-1.2-.5-1.3-1.1 0-.2 0-.4.1-.601l4.8-8.7z"></path><path fill="#28BF7B" d="M18.8.688c.5-.9 1.8-.9 2.3 0l8.601 15.6c.399.8-.2 1.7-1.101 1.7h-5.7v5.9c0 .6-.5 1.1-1.101 1.1h-3.6a1.11 1.11 0 0 1-1.101-1.1v-5.9H18.7c.7 0 1.2-.5 1.3-1.1 0-.2 0-.4-.1-.601l-4.801-8.7z"></path></symbol><symbol id="svg-logo" viewBox="0 0 206 206"><g fill-rule="evenodd" transform="translate(3 3)"><circle cx="100" cy="100" r="100" fill="none" stroke="currentColor" stroke-width="4"></circle><path d="m37.938 136.266 23.285-59.154 14.117 39.867 7.52 19.287h15.43L70.163 64H55.125L27 136.266m105.22 10.459v-9.327q-12.987-13.086-12.988-37.06 0-23.925 12.989-37.012V54q-12.11 6.738-19.165 19.238-7.056 12.5-7.056 27.1c0 14.6 2.393 18.831 7.178 27.295q7.178 12.694 19.043 19.092zm8.78 0q11.865-6.398 19.043-19.092 7.178-12.696 7.178-27.295c0-14.599-2.352-18.766-7.056-27.1Q153.109 60.738 141 54v9.326q12.988 13.086 12.988 37.012 0 23.974-12.988 37.06z"></path></g></symbol><symbol id="svg-npm" viewBox="0 0 55 55"><path d="M0 0v55h55V0zm45 45h-7.02V17.02H27.5V45H10V10h35z"></path></symbol><symbol id="svg-stackoverflow" viewBox="0 0 110 118"><path d="M84.072 107.351V75.8h10.516v42.069H0V75.8h10.516v31.551z"></path><path d="m22.089 72.898 51.458 10.815 2.163-10.292-51.458-10.815zm6.808-24.639 47.666 22.199 4.44-9.533-47.666-22.199zm13.191-23.385 40.405 33.65 6.73-8.081-40.405-33.65zM68.171 0l-8.438 6.276 31.381 42.191 8.438-6.276zM21.044 96.833h52.582V86.316H21.044z"></path></symbol><symbol id="svg-twitter" viewBox="0 0 134 106"><path fill-rule="evenodd" d="M0 93.992q2.96.331 6.596.331 19.029 0 33.912-11.428-8.88-.165-15.899-5.341-7.02-5.175-9.64-13.209 2.79.414 5.158.414 3.636 0 7.188-.91-9.471-1.905-15.687-9.234c-6.216-7.329-6.216-10.559-6.216-17.018v-.331q5.751 3.147 12.347 3.395-5.58-3.645-8.88-9.523-3.297-5.88-3.298-12.754 0-7.287 3.721-13.498 10.233 12.34 24.906 19.75 14.672 7.413 31.417 8.24a29 29 0 0 1-.677-6.128q0-11.097 7.992-18.922T92.264 0q11.839 0 19.958 8.447a54.3 54.3 0 0 0 17.336-6.46q-3.129 9.525-12.009 14.741 7.866-.828 15.73-4.14a56.6 56.6 0 0 1-13.7 13.83q.084 1.158.085 3.477 0 10.765-3.214 21.49t-9.768 20.58a81.4 81.4 0 0 1-15.602 17.43q-9.05 7.578-21.819 12.09-12.77 4.514-27.315 4.514-22.918 0-41.946-12.008z"></path></symbol><symbol id="svg-youtube" viewBox="0 0 512 512"><path d="M490.24 113.92c-13.888-24.704-28.96-29.248-59.648-30.976C399.936 80.864 322.848 80 256.064 80c-66.912 0-144.032.864-174.656 2.912-30.624 1.76-45.728 6.272-59.744 31.008C7.36 138.592 0 181.088 0 255.904v.256c0 74.496 7.36 117.312 21.664 141.728 14.016 24.704 29.088 29.184 59.712 31.264C112.032 430.944 189.152 432 256.064 432c66.784 0 143.872-1.056 174.56-2.816 30.688-2.08 45.76-6.56 59.648-31.264C504.704 373.504 512 330.688 512 256.192v-.256c0-74.848-7.296-117.344-21.76-142.016M192 352V160l160 96z"></path></symbol></svg>';
		this.styleEl.innerHTML = `ul {
	display: flex;
	flex-flow: row wrap;
	align-items: center;
	justify-content: center;
	padding: 0;
	margin: 0;
	list-style: none outside none;
}

li {
	padding: 0.5rem 0.325rem;
}

li a,
li svg {
	color: inherit;
	display: block;
}

img {
	vertical-align: middle;
}

li svg {
	fill: currentColor;
}

.svg-npm,
.svg-email,
.svg-github,
.svg-gitlab,
.svg-twitter,
.svg-codepen,
.svg-linkedin,
.svg-google-plus,
.svg-stackoverflow {
	width: 1.5rem;
}

.svg-npm,
.svg-codepen,
.svg-youtube,
.svg-linktree,
.svg-codersrank,
.svg-google-plus,
.svg-stackoverflow {
	height: 1.5rem;
}

.svg-npm {
	border-radius: 0.25rem;
}

.svg-email {
	height: 1.69rem;
}

.svg-github,
.svg-gitlab,
.svg-linkedin {
	height: 1.63rem;
}

.svg-twitter {
	height: 1.38rem;
}

.svg-youtube {
	width: 2rem;
}

.svg-logo {
	width: 1.75rem;
	height: 1.75rem;
	stroke: currentColor;
	stroke-width: 0.325rem;
}

.svg-codersrank {
	width: 2.5rem;
}

.svg-linktree {
	width: 1.75rem;
}
`;

		shadowRoot.appendChild(this.styleEl.cloneNode(true));
		shadowRoot.appendChild(this.sprite.content.cloneNode(true));
		shadowRoot.appendChild(this.template.content.cloneNode(true));
	}

	private render(): void {
		this.template.innerHTML = `<ul>${this.renderList()}</ul>`;
	}

	private renderList(): string {
		return this.items
			.map(
				(item: Link) => `<li>
					<a href="${item.url}" target="_blank" rel="noopener noreferrer" title="${item.title}">
						${this.renderIcon(item)}
					</a>
				</li>`
			)
			.join('\n');
	}

	private renderIcon(item: Link): string {
		return item.svg
			? `<svg class="svg-${item.icon}"><use xlink:href="#svg-${item.icon}"></use></svg>`
			: `<img src="${item.icon}" alt="" width="24" loading="lazy" />`;
	}
}

customElements.define('social-links', Socials);
